import styled from 'styled-components';

const colorTheme = {
  secondary: '#1b7bdd',
  red: '#ce445b',
  green: '#1ba39c',
};

export const TwoTextBox = styled.div`
  display: flex;
  padding: 0;

  @media (max-width: 575.98px) {
    display: inherit;
  }
`;

export const BoxOne = styled.div`
  background-color: #ebebeb;
  padding: 10vh 0;
  width: 50%;

  @media (max-width: 991.98px) {
    padding: 50px 30px;
  }

  @media (max-width: 575.98px) {
    width: 100%;
    padding: 50px;
  }
`;

export const BoxField = styled.div`
  padding-right: 0 !important;
  word-wrap: break-word;
`;

export const ArticleContent = styled.article`
  max-width: 375px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
  padding-bottom: 1.5rem;

  .cta-wrapper {
    padding-top: ${({ dir }) => (dir === 'rtl' ? '' : '1.5rem')};
  }

  @media (max-width: 575.98px) {
    width: 100%;
  }

  h2 {
    color: #4a4a4a !important;
    line-height: 1.4;

    @media (max-width: 1199.98px) {
      font-size: 26px;
      line-height: 1.4;
    }

    @media (max-width: 767.98px) {
      font-size: 20px;
      margin-bottom: 1rem;
      line-height: 1.4;
    }
  }

  p {
    margin: 0 0 10px;
    margin-bottom: 1.5rem;
    line-height: inherit;
  }
`;

export const BoxTwo = styled.div`
  background-color: #f7f7f7;
  padding: 10vh 0;
  width: 50%;

  @media (max-width: 991.98px) {
    padding: 50px 30px;
  }

  @media (max-width: 575.98px) {
    width: 100%;
    padding: 50px;
  }
`;

export const Content = styled.div`
  max-width: 375px;
  margin: 0 auto;
  position: relative;
  z-index: 2;

  h2 {
    color: #4a4a4a;
    line-height: 1.4;

    @media (max-width: 1198.98px) {
      font-size: 26px;
      line-height: 1.4;
    }

    @media (max-width: 767.98px) {
      font-size: 20px;
      margin-bottom: 1rem;
      line-height: 1.4;
      text-align: center;
    }

    @media (max-width: 575.98px) {
      text-align: center;
      margin-bottom: 2rem;
    }
  }

  @media (max-width: 575.98px) {
    width: 100%;
  }
`;

export const UlKeys = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
`;

export const LiItem = styled.li`
  color: #898989;
  margin-bottom: 1.5rem;
  position: relative;
  min-height: 33px;

  .list-icon {
    position: absolute;
    top: 0;
  }

  &[dir='ltr'] {
    padding-left: 80px;
    .list-icon {
      left: 0;
    }

    @media (max-width: 767px) {
      padding-left: 52px;
    }
  }

  &[dir='rtl'] {
    padding-right: 47px;
    .list-icon {
      right: 0;
    }

    @media (max-width: 767px) {
      padding-right: 52px;
    }
  }

  svg {
    width: 33px;
    height: 32px;
    fill: ${({ color }) => colorTheme[color]};
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const LeftColumnSubtitle = styled.p`
  &[dir='ltr'] {
    font-family: 'DINRegular';
    letter-spacing: 1.29px;
  }

  font-size: ${({ dir }) => (dir === 'rtl' ? '14px' : '16px')};
  margin-bottom: 1.5rem !important;
  line-height: 20px;
  text-decoration: none solid rgb(74, 74, 74);
  word-spacing: 0px;
  color: ${({ dir }) => (dir === 'rtl' ? '#000' : '#4a4a4a')};
`;
